import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import classnames from "classnames";

// hooks
import { useRedux } from "../../hooks/index";

// hooks
import { useConversationUserType } from "../../hooks/index";
import { createSelector } from "reselect";
// component
import Leftbar from "./Leftbar";
import ConversationUser from "./ConversationUser/index";
import UserProfileDetails from "./UserProfileDetails/index";
import Welcome from "./ConversationUser/Welcome";
import ViewMsgMemberModal from "components/ViewMsgMemberModal";
import {
  getChatUserDetails2s
  , readConversation, getChatUserConversations2, changeSelectedChat
  , setActiveGroupId
  , setPermNotification
} from "../../../src/redux/actions";
import ContentList from "./Content/ContentList";
import { TABS, WpModes } from "../../constants/index";
import WelcomeWorkplace from "./ConversationUser/WelcomeWorkplace";
import WorkplaceContent from "./Workplace/WorkplaceContent";
import { WpSliceData } from "../../redux/workplace/wpTypes";
import DataSettingPage from "./Settings/DataSettingPage";
import { PERMS, TOOLS } from "const";
import DataSettingFollower from "./Settings/DataSettingFollower";
import PermConfig from "components/PermConfig";
import FloatingToolbox from "components/FloatingToolbox";
import WpTagToolbox from "./Common/WpTagToolbox";
import Content2SOnlinePendingDO from "./Content/Content2SOnlinePendingDO";
import MasterPage2Column from "pages/MasterPage2Column";
import DataSettingQuickReply from "./Settings/DataSettingQuickReply";
import DataSettingGroupMember from "./Settings/DataSettingGroupMember";
import DataSettingSyncErpData from "./Settings/DataSettingSyncErpData";
import DataSettingGeneral from "./Settings/DataSettingGeneral";
import DataSettingOnlineUser from "./Settings/DataSettingOnlineUser";
import DataSettingNotificationGlobal from "./Settings/DataSettingNotificationGlobal";
import WelcomeTask from "./ConversationUser/WelcomeTask";
import { UserTypes } from "../../api";
import { loadTaskDashActV2, loadTaskDashRecurance, tagMasterCatLoad } from "../../redux/workplace/wpActions";
import WelcomeTask2 from "./ConversationUser/WelcomeTask2";
import DataSettingTaskRecurance from "./Settings/DataSettingTaskRecurance";
import { StorageUtils } from "helpers/storageutils";
import DataSettingExternalUser from "./Settings/DataSettingExternalUser";
import DataSettingHookManager from "./Settings/DataSettingHookManager";
import ContentUploadSlip from "./Content/ContentUploadSlip";
import { Utils } from "helpers/utils";
import ApprovalCenter from "./Approval";

interface IndexProps { }
const Index = (props: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();
  const location = useLocation();

  const errorData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.Layout,
    (state: any) => state.WpSlice,
    (state: any) => state.Settings,
    (state: any) => state.Profile2,
    (state, layout, wp: WpSliceData, st, p2) => ({
      selectedChat: state.selectedChat,
      selectedContentTitle: state.selectedContentTitle,
      selectedContentTitleMode: state.selectedContentTitleMode,
      viewMsgMemberModalOpen: state.viewMsgMemberModalOpen,
      activeTab: layout.activeTab,
      activePostId: wp.activePostInfo.postId,
      //activeTaskId: wp.activeTaskInfo.postId,
      activeTool: st.activeTool,
      isInFrame: layout.isInIFrame,
      curUserId: p2.userId,
      curUserType: p2.userType,
    })
  );

  const { selectedChat, selectedContentTitle, selectedContentTitleMode, viewMsgMemberModalOpen, activeTab, activePostId, /*activeTaskId,*/ activeTool, isInFrame, curUserId, curUserType } = useAppSelector(errorData);

  // console.log('activePostId='+(activePostId !== null));
  const { isChannel } = useConversationUserType();

  useEffect(() => {
    dispatch(setPermNotification(true)); // first set allow
    setTimeout(() => {
      Utils.IsPushNotificationGrantedAsync().then((granted) => dispatch(setPermNotification(granted)));
    }, 2000); // wait 1 second to get permission, just in case some time permission value not yet validate when start
  }, []);

  useEffect(() => {
    Utils.IsPushNotificationGrantedAsync().then((granted) => dispatch(setPermNotification(granted))); // refresh permission icon
    // console.log('set permission');
  }, [activeTab]);

  // useEffect(() => { console.log('run in frame = ' + isInFrame) }, [isInFrame]);

  useEffect(() => {
    StorageUtils.DashboardFilterTagId = null;
    if (curUserId > 0 && (curUserType == UserTypes.Employee || curUserType == UserTypes.ExternalUser)) {
      dispatch(loadTaskDashActV2(StorageUtils.TaskDashDivMode, null, null, null, StorageUtils.TaskDashIncludeTaskRecurance));
      dispatch(loadTaskDashRecurance());
    }
  }, [curUserId, curUserType]);

  useEffect(() => {
    if (curUserType === UserTypes.Employee || curUserType === UserTypes.ExternalUser) {
      dispatch(tagMasterCatLoad());
    }
  }, [curUserType]);

  return (
    <>
      {!isInFrame && (<Leftbar />)}{/* 20250621 not render leftbar if run in iframe */}

      <div
        className={classnames("user-chat", "w-100 ", "overflow-hidden", {
          "user-chat-show": selectedChat || selectedContentTitle || activePostId !== null || activeTool,
        })}
        id="user-chat"
      >
        <div className="user-chat-overlay" id="user-chat-overlay"></div>

        {(selectedChat !== null && activePostId === null) ? (
          <div className="chat-content d-md-flex">
            <div className="w-100 overflow-hidden position-relative">
              <ConversationUser isChannel={isChannel} />
            </div>
            <UserProfileDetails isChannel={isChannel} />
          </div>
        ) : activePostId !== null ? (
          <div className="chat-content d-md-flex ">
            <div className="w-100 overflow-hidden position-relative">
              <WorkplaceContent wpMode={activeTab == TABS.WORKPLACE ? WpModes.Workplace : WpModes.Task} instantMode={false} />
            </div>
          </div>
        ) : selectedContentTitle !== null ? (
          <div className="chat-content d-md-flex">
            <div className="w-100 overflow-hidden position-relative">
              {selectedContentTitleMode === "UploadPaymentSlip" ? (<ContentUploadSlip />) : (<ContentList />)}
            </div>
          </div>
        ) : (isInFrame) ? (
          <span className="text-danger">Working in emmbeded mode</span>
        ) : (activeTool == TOOLS.TAG_WORK_PLACE_MANAGE/* || true*/) ? (
          <DataSettingPage />
        ) : (activeTool == TOOLS.QUICK_CHAT_REPLY/* || true*/) ? (
          <DataSettingQuickReply />
        ) : (activeTool == TOOLS.NOTIFICATION_GLOBAL /* || true*/) ? (
          <DataSettingNotificationGlobal />
        ) : (activeTool == TOOLS.GROUP_CHAT_MEMBER/* || true*/) ? (
          <DataSettingGroupMember />
        ) : (activeTool == TOOLS.SYNC_ERP_DATA) ? (
          <DataSettingSyncErpData />
        ) : (activeTool == TOOLS.TASK_RECURANCE /*|| true*/) ? (
          <DataSettingTaskRecurance />
        ) : (activeTool == TOOLS.EXTERNAL_USER /*|| true*/) ? (
          <DataSettingExternalUser />
        ) : (activeTool == TOOLS.HOOK_MANAGER /*|| true*/) ? (
          <DataSettingHookManager />
        ) : (activeTool == TOOLS.GENERAL_SETTING /*|| true*/) ? (
          <DataSettingGeneral />
        ) : (activeTool == TOOLS.ONLINE_USER /*|| true*/) ? (
          <DataSettingOnlineUser />
        ) : (activeTool == TOOLS.TAG_WORK_PLACE_FOLLOWER /*|| true*/) ? (
          <DataSettingFollower />
        ) : (activeTool == TOOLS.PERM_VISIBLE_CHAT_ICON /*|| true*/) ? (
          <PermConfig permName={PERMS.VISIBLE_CHAT_ICON} defaultAllow={true} />
        ) : (activeTool == TOOLS.PERM_VISIBLE_CHAT_ICON_SUP /*|| true*/) ? (
          <PermConfig permName={PERMS.VISIBLE_CHAT_ICON_SUPPLIER} defaultAllow={true} />
        ) : activeTab == TABS.WORKPLACE ? (
          <WelcomeWorkplace />
        ) : activeTab == TABS.TASK /*|| true*/ ? (
          <WelcomeTask2 />
        ) : activeTab == TABS.APPROVAL ? (
          <ApprovalCenter />
        ) : (
          <Welcome />
        )}

        {/* {selectedChat !== null ? (
          <div className="chat-content d-md-flex">
            <div className="w-100 overflow-hidden position-relative">
              <ConversationUser isChannel={isChannel} />
            </div>
            <UserProfileDetails isChannel={isChannel} />
          </div>
        ) : (
          <>
            {selectedContentTitle !== null
              ? (
                <div className="chat-content d-md-flex">
                  <div className="w-100 overflow-hidden position-relative">
                    <ContentList />
                  </div>
                </div>
              )
              : (
                activeTab == TABS.WORKPLACE ? (<WelcomeWorkplace />) : (<Welcome />)
              )}
          </>
        )} */}
      </div>
      {/* <FloatingToolbox name="WpTagToolbox" title="Set Tag WorkPlace" isOpen={true} toggle={()=>{}} >
        <WpTagToolbox isOpen={true}/>
      </FloatingToolbox> */}
    </>
  );
};

export default Index;
